// extracted by mini-css-extract-plugin
module.exports = {"main":"BetaSticker_main__lMuj7","mainFeature":"BetaSticker_mainFeature__sn0B7"};